/**
 * @param {string} author Ex: "0x00 <0x00@example.com>"
 * @return {{name: (*|string|string), email: (*|string|string)}}
 */
export function parseAuthorName(author) {
	const match = author.match(/^(.+)\s+<([^>]+)>$/);
	return {
		name: match[1] || 'unknown',
		email: match[2] || 'unknown',
	}
}
